/**
 * LoadingState — centered loading indicator with optional label.
 * Minimal, quiet.
 */

import { Spinner } from '../Spinner';
import { cn } from '@/lib/cn';

export interface LoadingStateProps {
  label?: string;
  className?: string;
}

export function LoadingState({ label = 'Loading...', className }: LoadingStateProps): JSX.Element {
  return (
    <div
      className={cn('flex flex-col items-center justify-center gap-3 p-16', className)}
      role="status"
      aria-live="polite"
    >
      <Spinner size="md" />
      <p className="text-xs text-muted-foreground tracking-wide">{label}</p>
    </div>
  );
}
